module.exports = __webpack_public_path__ + "static/media/on_prem_overview.ec80ee77.png";